module.exports = __webpack_public_path__ + "img/cTrader-icon2.2149b47.png";